<template>
  <div class="card">
    <div class="flex-s-s" style="position: relative">
      <div class="flex-s-c score-card" style="cursor: pointer;" @click="detail({row:{yearSelect:scoreMess.yearSelect,totalIntegral:scoreMess.totalIntegral}})">
        <div>
          <i class="iconfont icon-jifen1"></i>
          <div class="mat10">本年度积分（分）</div>
        </div>
        <div class="value">{{scoreMess.totalIntegral}}</div>
      </div>
      <ul class="key-value">
        <li v-for="item in examineList">
          <div class="key">{{item.key}}：</div>
          <div class="value">{{item.value}}</div>
        </li>
      </ul>
      <div class="rule" @click="showRule">积分规则</div>
    </div>
    <div class="flex-s-c" style="margin:0 0 20px">
      <i class="iconfont icon-jifen" style="color:#ffba00;font-size:26px;margin-right:6px"></i>
      <span>积分详情</span>
    </div>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column :prop="item.prop" :label="item.label" :width="item.width" v-for="item in column" :key="item.prop">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click.stop="detail(scope)" type="text">明细</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      examineList: [
        { key: "服务年限 ", value: "2010-10-10" },
        { key: "志委会年限", value: "12人" },
        { key: "展厅数量", value: "2010-10-10" }
      ],
      tableData: [],
      column: [
        { prop: "yearSelect", label: "年度", width: "" },
        { prop: "totalIntegral", label: "积分", width: "" },
        { prop: "serviceLength", label: "时长", width: "" },
        { prop: "integralResult", label: "等级", width: "" },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 100,
      dialogVisible: false,
      scoreMess: {},
      userMess: this.$store.state.user.user,
    };
  },
  computed: {},
  watch: {},
  methods: {
    getList() {
      // console.log(params)
      let params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        volunteerId: this.userMess.id
      }
      this.$api.getIntegralResultList(params).then(res => {
        // console.log(res)
        // this.tableData = res.data.rows
        let list = res.data.rows
        this.tableData = list.map(item => {
          return { ...item, serviceLength: item.serviceLength + 'H' }
        })
        this.total = res.data.total
      })
    },
    //积分规则
    showRule() {
      this.$api.integrationList().then(res => {
        // console.log(res)
        let _this = this
        this.$confirm({
          title: "积分规则",
          content: res.data.content,
          head: res.data.title,
          confirm: true,
          dialogVisible: true,
          btn: {
            confirmVal: "确定",
          }
        }).then((res) => {
          // console.log("sssss")
          // console.log("yes", res);

          //点击确定之后的处理
        }).catch((err) => {
          // console.log("no", err);
        });
      })
    },
    //获取积分信息
    getScore() {
      this.$api.getCurrentIntegral({ volunteerId: this.userMess.id }).then(res => {
        // console.log(res)
        this.scoreMess = res.data
        this.examineList = [
          { key: "年份", value: res.data.yearSelect + '年' },
          { key: "服务年限 ", value: res.data.serviceYear + '年' },
          // { key: "志委会年限", value: "12人" },
        ]
      })
    },
    detail(scope) {
      console.log(scope)
      this.$router.push({ name: 'myScoreDetail', params: { year: scope.row.yearSelect, score: scope.row.totalIntegral } })

    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
      // console.log(`当前页: ${val}`);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList();
    this.getScore()
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
@import "./score.less";
</style>
